import { RouteObject } from "react-router-dom";
import { NotFound } from "../../../commons/components";
import AuthGuardWrapper from "../../auth/AuthGuardWrapper";
import { ManageFootballTeam } from "../../../commons/models/football/admin/manage-football-team";
import HostedTournamentDetailManage from "./HostedTournamentDetailManage";
import TournamentManageTeams from "../tournaments/TournamentManageTeams";
import HostedTournamentManageProfile from "./HostedTournamentManageProfile";
import TournamentManageEvents from "../tournaments/TournamentManageEvents";
import TournamentManageStandings from "../tournaments/TournamentManageStandings";
import { routerAdminMatch } from "../match/routesAdminMatch";

const HOSTED_TOURNAMENT_PROFILE = "profile";
const HOSTED_TOURNAMENT_TEAM = "teams";
const HOSTED_TOURNAMENT_EVENTS = "events";
const HOSTED_TOURNAMENT_STANDINGS = "standings";
const HOSTED_TOURNAMENT_MATCH = "matches";

export const routerAdminHostedTournament: RouteObject[] = [
  {
    path: "",
    element: (
      <AuthGuardWrapper subject={ManageFootballTeam}>
        <HostedTournamentDetailManage />
      </AuthGuardWrapper>
    ),
    children: [
      { index: true, element: <HostedTournamentManageProfile /> },
      { path: HOSTED_TOURNAMENT_PROFILE, element: <HostedTournamentManageProfile /> },
      { path: HOSTED_TOURNAMENT_TEAM, element: <TournamentManageTeams /> },
      { path: HOSTED_TOURNAMENT_EVENTS, element: <TournamentManageEvents /> },
      { path: HOSTED_TOURNAMENT_STANDINGS, element: <TournamentManageStandings /> },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    id: "hostedTournamentMatchDetail",
    path: "seasons/:seasonId",
    children: [{ path: HOSTED_TOURNAMENT_MATCH, children: routerAdminMatch }],
  },
];
